import { css as e } from "styled-components";
const r = (o) => o.componentColors.forms.checkbox, s = {
  base: () => /* @__PURE__ */ e([
    "cursor:pointer;display:flex;justify-content:center;align-items:center;height:2.4rem;width:2.4rem;box-sizing:border-box;border-style:solid;border-width:0.2rem;"
  ]),
  hidden: ({ theme: o, error: c }) => /* @__PURE__ */ e([
    "position:absolute;opacity:0;height:1px;width:1px;&:focus{& ~ .styled-checkbox{",
    " border-color:",
    ";}}& ~ .styled-checkbox{border-color:",
    ";background-color:",
    ";& svg{visibility:hidden;}}&:checked{& ~ .styled-checkbox{border-color:",
    ";background-color:",
    ";& svg{visibility:visible;}}}"
  ], o.components.forms.borderStyle, r(o).borderColor, c ? r(o).errorColor : r(o).borderColor, r(o).uncheckedColor, r(o).checkedColor, r(o).checkedColor)
};
export {
  s as default
};
